import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

import Config from 'utils/config'

import API from 'utils/api/api'
import APPURL from 'utils/app/urls'
import AppTools from 'utils/app/appTools'
import RegionTools from 'utils/regions/regionTools'
import IndicatorTools from 'utils/indicators/indicatorTools'

import ReportTableRowContainer from 'modules/Charts/ReportTableRow/ReportTableRowContainer'

import Loading from 'components/Loading'
import Error from 'components/Error'

import messages from './messages'
import { exportToExcel } from './ReportTableExcelHelper'


const DEFAULT_PRECISION = 1;  // decimals to show


class ReportTableContainer extends Component {
  constructor(props) {
    super(props)

    const {
			intl: { formatMessage }
		} = props
		this.formatMessage = formatMessage

    this.state = {
      layer: 1,
      loading: true,
      error: false,
      reportDataRows: {}
    }
  }

  componentDidMount() {
    document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll')
    this.loadData()
    let url = this.props.history.location.pathname
    let layer = APPURL.getLayerFromURL(url)
    this.setState({ layer })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.selectedRegionId !== prevProps.selectedRegionId) {
      this.loadData()
    }
  }

  loadData() {
    if (this.props.selectedRegionId === null) return

    const p1 = API.getRegions().then(regions => RegionTools.getDataFromRegions(regions))

    const p4 = API.getIndicators().then(indicators => IndicatorTools.getDataFromIndicators(indicators))

    const p5 = API.getIndicatorsStatus().then(indicatorsStatus => indicatorsStatus.last_checked_on)

    const p6 = API.getCountries().then(countries => RegionTools.getDataFromCountries(countries))

    Promise.all([p1, p4, p5, p6])
      .then(values => {
        this.props.setRegionsData(values[0])
        if (Config.getConfig().app.USE_REFREGIONS) {
          this.props.setReferenceRegionsData(values[1]);
          this.props.setIndicatorsData(values[2]);
          this.props.setIndicatorsLastUpdated(values[3]);
          this.props.setCountriesData(values[4]);
        } else {
          this.props.setIndicatorsData(values[1]);
          this.props.setIndicatorsLastUpdated(values[2]);
          this.props.setCountriesData(values[3]);
        }

        let selectedRegionMeta = values[0].filter(region => Number(region.id) === Number(this.props.selectedRegionId))[0]

        let selectedRegionCountryMeta = RegionTools.countryCodeToMeta(
          RegionTools.getCountryCodeFromRegionCode( selectedRegionMeta.code )
        )
        this.props.setSelectedRegionCountryMeta(selectedRegionCountryMeta);
      })
      .then(() => {
        this.setState({ loading: false, error: false })
      })
      .catch(reason => {
        this.setState({ error: true, loading: false })
      })
  }

  composeTableBodySections = ( table ) => {
    let sections = table["items"];
    let tbodies = [];
		let title = AppTools.getSectionText( "report", [table.title_id], "title" );

    tbodies.push(
      <React.Fragment key={table.title_id}>
        <div className="row section" id={"anchor-dimension-" + table.anchor_id}>
          <div className="col-sm-12">{title.toUpperCase()} <a href="#anchor-report-table-index"><i className="fal fa-arrow-to-top"></i></a>
          </div>
        </div>
      </React.Fragment>
    );
		for (let i = 0; i < sections.length; i++) {
			tbodies.push(this.composeTableBodySection(sections[i]))
		}

    return <React.Fragment key={table.title_id}>
      <div className={"row " + table["style"]}>
        <div className="col-sm-12">{tbodies}</div>
      </div>
      </React.Fragment>;
  }

  composeTableBodySection = ( section ) => {
    let indicator_defs = section["items"].map(e => {
      let decimals = e.length > 2 ? e[2] : DEFAULT_PRECISION;
      let ignoreColor = section["ignoreColor"] || false;
      return {
        "id": e[1],
        "precision": decimals,
        "ignoreColor": ignoreColor
      };
    });
    let title = AppTools.getSectionText( "report", [section.title_id], "title" );

    let tbody = (
      <React.Fragment key={section.title_id}>
        <div className="row sub-section">
          <div className="col-sm-12">{title}</div>
        </div>
        {this.composeTableBodyRows(indicator_defs)}
      </React.Fragment>
      );

    return tbody;
  }

  addDataRow = ( rowId, data ) => {
    this.setState( (prevState) => ({
      reportDataRows: {...prevState.reportDataRows, [rowId]: data}
    }));
  }

  composeTableBodyRows = ( indicator_defs ) => {
		let rows = [];

    const handleRowUpdate = (rowId, data) => {
      // console.log(`Received from row ${rowId}:`, data);
      // setMasterData(prev => ([ ...prev, data ]));
      this.addDataRow( rowId, data );
    };

		for (let i = 0; i < indicator_defs.length; i++) {
			rows.push(<ReportTableRowContainer 
        key={indicator_defs[i].id}
        indicator={indicator_defs[i].id} 
        precision={indicator_defs[i].precision}
        ignoreColor={indicator_defs[i].ignoreColor}
        sendDataUp={handleRowUpdate} />)
		}

		return rows;
	}

  renderIfAllOK() {
    let renderingComponent = null
    if (this.state.error) {
      renderingComponent = <Error />
    } else if (this.state.loading) {
      renderingComponent = <Loading />
    } else {
      // let indicators = Config.getProperty("report-table")[0].map(e => e[1]);
      // let section = Config.getProperty("report-table")[0]["items"][0];
      // let table0 = Config.getProperty("report-table")[0];
      // let table1 = Config.getProperty("report-table")[1];
      // let table2 = Config.getProperty("report-table")[2];
      const reportTableDefinition = Config.getProperty("report-table");
      let dimensionSections = reportTableDefinition.map((table) => this.composeTableBodySections(table));

      let header = [
        this.formatMessage(messages.columnIndicator),
        "Unidad",
        this.formatMessage(messages.columnYear),
        this.formatMessage(messages.columnValue),
        this.formatMessage(messages.columnEvo),
        // this.formatMessage(messages.columnEvoLastYear),
        // this.formatMessage(messages.columnEU27Header),
        this.formatMessage(messages.columnYear),
        this.formatMessage(messages.columnLevel),
        this.formatMessage(messages.columnChange)
      ];

      const lastUpdated = this.props.lastUpdated;

      const exportExcel = () => {
        exportToExcel( this.state.reportDataRows, reportTableDefinition, header, lastUpdated );
      };

      renderingComponent = (
        <React.Fragment>
          <div className="report-table" id="anchor-report-table-index">
            <div className="row report-table-head visible-lg">
              <div className="col-lg-7 text-left report-table-head-col">{header[0]}</div>
              <div className="col-lg-5">
                <div className="row">
                  <div className="col-lg-2 report-table-head-col">{this.formatMessage(messages.columnYear)}</div>
                  <div className="col-lg-2 report-table-head-col">{this.formatMessage(messages.columnValue)}</div>
                  <div className="col-lg-2 report-table-head-col">{this.formatMessage(messages.columnEvo)}<br/><small className="text-gray-600">({this.formatMessage(messages.columnEvoLastYear)})</small></div>
                  <div className="col-lg-6">
                    <div className="col-lg-12 report-table-head-col">{this.formatMessage(messages.columnEU27Header)}</div>
                    <div className="col-lg-4 report-table-head-col"><small>{this.formatMessage(messages.columnYear)}</small></div>
                    <div className="col-lg-4 report-table-head-col"><small>{this.formatMessage(messages.columnLevel)}</small></div>
                    <div className="col-lg-4 report-table-head-col"><small>{this.formatMessage(messages.columnChange)}</small></div>
                  </div>
                </div>
              </div>
            </div>
            {dimensionSections}
            {/* {this.composeTableBodySections(table0)}
            {this.composeTableBodySections(table1)}
            {this.composeTableBodySections(table2)} */}
            <button onClick={exportExcel} className="btn-excel">
              Exportar a Excel
            </button>
          </div>
        </React.Fragment>
      )
    }
    return renderingComponent
  }

  render() {
    return <div className="container-fluid ork-gray-box">{this.renderIfAllOK()}</div>
  }
}

export default injectIntl(ReportTableContainer);



// WEBPACK FOOTER //
// ./src/modules/Content/ReportTableContainer/ReportTableContainer.jsx